export default __webpack_public_path__ + "static/media/solarwaterheat.6bbcecfe.png";